import { useState } from 'react';
import { Tooltip } from 'antd';
import TablePage from '../../../../../components/pages/TablePage'
import moment from 'moment';
import DetailPage from './detail';
import { RiFilePptLine } from "react-icons/ri";
import { useDispatch } from 'react-redux';
import { PostAPI } from '../../../../../redux';

export default () => {

    const dispatch = useDispatch();
    const [refresh, setRefresh] = useState(moment().unix())

    const handleCreatedRksp = (id) => {
        const url = `api/v1/bc_params/create_rskp/${id}`
        const data = {};
        dispatch(PostAPI({ url, data })).then(resp => {
            setRefresh(moment().unix())
        })
    }

    const columns = [
        {
            selector: (row) => {
                return (
                    <>
                        {row?.rskp_exists === false &&
                            <Tooltip title="create rksp">
                                <RiFilePptLine style={{ marginLeft: 20 }} size={20} onClick={() => handleCreatedRksp(row?._id)} />
                            </Tooltip>
                        }
                    </>
                )
            },
            name: "Action",
            id: 'created_at',
            width: "100px"
        },
        {
            selector: ({ airline_str }) => airline_str,
            name: "Airline",
            id: 'airline_str'
        },
        {
            selector: ({ flight_number }) => flight_number,
            name: "Flight Number",
            id: 'flight_number'
        },
        {
            selector: ({ acreg }) => acreg,
            name: "Registration",
            id: 'acreg'
        },
        {
            selector: ({ flight_date_str }) => flight_date_str,
            name: "Flight Date",
            id: 'flight_date_str'
        },
        {
            selector: ({ route }) => route,
            name: "Route",
            id: 'route'
        },
        {
            selector: ({ total }) => total,
            name: "Koli",
            id: 'total'
        },
        {
            selector: ({ weight }) => weight,
            name: "Kilo",
            id: 'weight'
        },
        {
            selector: ({ volume }) => volume,
            name: "Volume",
            id: 'volume'
        },
        {
            selector: (row) => (row?.createdAt && moment(row.createdAt).format('DD-MMM-YYYY HH:mm:ss')) || '-',
            name: "CreatedAt",
            id: 'created_at'
        }
    ]

    return (
        <TablePage
            title={"Domestic Flight Manifest"}
            url="api/v1/flight_number/manifest/domestic"
            columns={columns}
            ExpandComponent={DetailPage}
            refresh={refresh}
        />
    )
}